import { GatewayCard } from '../general';
import { getExchangeOidcToken } from '@sonar-software/sonar-security';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { useOnMount } from '@hooks';

import { FULL_ROUTES, INTEGRATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { getIdTokenQuery, getQueryStringParameter, removeJWTToken, setJWTToken } from '@sonar-software/sonar-ts-lib';
import React, { useState } from 'react';

async function exchangeOIDCToken(originalToken: string): Promise<void> {
	setJWTToken(originalToken);

	try {
		const response = await getExchangeOidcToken();

		if (response.data?.localUserIdToken) {
			setJWTToken(response.data.localUserIdToken);
			const extension = getQueryStringParameter(window.location.search, 'extension');
			window.location.replace(`${FULL_ROUTES.ONBOARDING_CONNECT}${extension ? 'extension=true' : ''}`);
		} else {
			throw new Error('Unable to exchange OIDC token.');
		}
	} catch (ex) {
		removeJWTToken();
	}
}

export const OIDCIntegration: React.FC = () => {
	const [ errorDescription, setErrorDescription ] = useState<string>();

	useOnMount(() => {
		const idToken = getIdTokenQuery(window.location.hash) as string;
		const error = getQueryStringParameter(window.location.hash.slice(1), 'error_description');

		if (error) {
			setErrorDescription(error);
		}

		exchangeOIDCToken(idToken);
	});

	return (
		<GatewayCard title={ errorDescription ?? INTEGRATIONS_COPY.OIDC_LOGIN }>
			{ errorDescription ? null : <LoadingSpinner spinning /> }
		</GatewayCard>
	);
};
